export default __webpack_public_path__ + "images/logo-blanco.9b6966cc72df47c8f71d1bf0b046c174.svg";